/** Keep in sync with services/api/src/python-indent.ts */

export const PEP8_INDENT_SPACES = 4;
const TAB_WIDTH = 4;

function expandTabsInIndent(indent: string): string {
  let col = 0;
  let out = "";
  for (const ch of indent) {
    if (ch === "\t") {
      const spaces = TAB_WIDTH - (col % TAB_WIDTH);
      out += " ".repeat(spaces);
      col += spaces;
    } else if (ch === " ") {
      out += ch;
      col += 1;
    }
  }
  return out;
}

function gcd(a: number, b: number): number {
  let x = Math.abs(a);
  let y = Math.abs(b);
  while (y) {
    const t = y;
    y = x % y;
    x = t;
  }
  return x || 1;
}

function detectIndentStep(lines: readonly string[]): number {
  const widths: number[] = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) continue;
    const m = line.match(/^[\t ]+/);
    if (!m) continue;
    const expanded = expandTabsInIndent(m[0]);
    if (expanded.length > 0) widths.push(expanded.length);
  }
  if (widths.length === 0) return PEP8_INDENT_SPACES;
  let step = widths[0]!;
  for (let i = 1; i < widths.length; i++) step = gcd(step, widths[i]!);
  return step;
}

export function normalizePythonIndentation(code: string): string {
  if (!code) return code;
  const endsWithNewline = code.endsWith("\n");
  const lines = code.split("\n");
  const step = detectIndentStep(lines);

  const normalized = lines.map((line) => {
    if (!line.trim()) return line.replace(/\t/g, " ".repeat(TAB_WIDTH));
    const m = line.match(/^([\t ]+)/);
    if (!m) return line;
    const expanded = expandTabsInIndent(m[0]);
    const level = Math.round(expanded.length / step);
    const newIndent = " ".repeat(level * PEP8_INDENT_SPACES);
    return newIndent + line.slice(m[0].length);
  });

  const joined = normalized.join("\n");
  return endsWithNewline && lines.length > 0 ? `${joined}\n` : joined;
}
